export default class RelatedItemsSlider {
    constructor() {
        if (Electro.DEBUG) {
            console.info('RelatedItemsSlider.constructor()');
        }

        this.sliderOptions = {
            rows: false,
            mobileFirst: true,
            autoplay: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            focusOnChange: true,
            accessibility: true,
            responsive: [
                {
                    breakpoint: 641,
                    settings: 'unslick',
                },
            ],
        };

        this.$collapseSlider = $('.slick-slider.related-items');
        this.$collapseSlider.slick(this.sliderOptions);

        this.resetTabindex();

        this.$collapseSlider.on('breakpoint', () => {
            this.resetTabindex();
        });

        this.initListeners();
    }

    resetTabindex() {
        const slides = document.querySelectorAll('.slide');

        slides.forEach((slide) => {
            $(slide).attr('tabindex','0');
        });
    }

    initListeners() {
        if (Electro.DEBUG) {
            console.info('RelatedItemsSlider.initListeners()');
        }

        $(window).on('resize', () => {
            if ($(window).width() > 640) {
                if (this.$collapseSlider.hasClass('slick-initialized')) {
                    this.$collapseSlider.slick('unslick');
                }
            } else if (!this.$collapseSlider.hasClass('slick-initialized')) {
                this.$collapseSlider.slick(this.sliderOptions);
            }
        });
    }
}
